export default "__VITE_ASSET__D9y6in$Y__"